import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MasipService } from '../../services/masip.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-change-page-dialog',
  standalone: false,
  templateUrl: './change-page-dialog.component.html',
  styleUrl: './change-page-dialog.component.scss'
})
export class ChangePageDialogComponent {



  constructor(
    public dialogRef: MatDialogRef<ChangePageDialogComponent>,
    private masipService: MasipService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { profile: any, },
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }

  goTo(url: string) {
    this.router.navigateByUrl(url);
    this.dialogRef.close('close');
  }
}
